import { html } from 'lit-html';
import { RecentCheckedItemJsEnv } from '../../../models/recent_checked_item/recent_checked_item_js_env';
import { RecentCheckedItems } from './recent_checked_items';

export const RecentCheckedItemArea = (model: RecentCheckedItemJsEnv) => html`
  <div class="o-footer_recentCheckItems js-carousel-parent">
    <div class="o-colBox -margin24">
      <div class="a-heading -typeh3 u-mb-24">
        <h2 class="a-heading_text">最近チェックした商品</h2>
      </div>
      <p class="a-text"><a href="/as/recentchecked/recentChecked/" class="a-textlink">一覧を見る</a></p>
    </div>
    ${RecentCheckedItems(model)}
  </div>
`;
